module.exports = __webpack_public_path__ + "img/logo2.e54c60e9.png";